exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.search-customer[data-v-029c8b2d] {\r\n  margin-bottom: 56px;\n}\r\n", ""]);

